<template>
    <div class="preview-area">
        <div class="preview-box" :style="style" />
    </div>
</template>

<script src="./script.js" />
